import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "label" }

import BasicButton from "./BasicButton.vue";
import { Icon } from "@iconify/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonIcon',
  props: {
    label: {},
    iconName: {},
    color: {},
    iconPosition: { default: "end" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasicButton, _mergeProps({ color: __props.color }, _ctx.$attrs, {
    class: ['button-icon', `button-icon--${__props.iconPosition}`]
  }), {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1),
      _createVNode(_unref(Icon), {
        icon: __props.iconName,
        class: "icon",
        width: 16,
        height: 16
      }, null, 8, ["icon"])
    ]),
    _: 1
  }, 16, ["color", "class"]))
}
}

})